import { AnalyticsService } from './../../../services/analytics.service';
import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { Observable, Subject, debounceTime, fromEvent, takeUntil } from 'rxjs';
import { CtvtVoltageLevel, CtvtVoltageLevelDisplay } from 'src/app/enums/ctvt-voltage-level.enum';
import { MeterInventoryType } from 'src/app/enums/meter-inventory-type.enum';
import { MeterManagementStatsOptions } from 'src/app/enums/meter-management-stats-options.enum';
import { Area } from 'src/app/models/area.model';
import { ChecklistItem } from 'src/app/models/checklist-item.model';
import { CustomerType, TypeOfConnection } from 'src/app/models/customer.model';
import { MeterModel, SortByOptions } from 'src/app/models/meter.model';
import {
  MeterStockItem,
  MeterStockItemStats,
} from 'src/app/models/meterStockItem.model';
import { MeterRating } from 'src/app/models/meterRating.model';
import { NewMeterStockItemDto } from 'src/app/models/newMeterStockItemDto.model';
import { Region } from 'src/app/models/region.model';
import { OptionObj } from 'src/app/models/util.model';
import { AreaService } from 'src/app/services/area.service';
import { AuthService } from 'src/app/services/auth.service';
import { MeterManagementService } from 'src/app/services/meter-management.service';
import { DtMeterTypeService } from 'src/app/services/dt-meter-type.service';
import { DtMeterType } from 'src/app/models/dtMeterType.model';
import { MeterModelService } from 'src/app/services/meter-model.service';
import { MeterRatingService } from 'src/app/services/meter-rating.service';
import { MeterService } from 'src/app/services/meter.service';
import { GeographicalRegion, GeographicalRegionService, PermissionsService, SubGeographicalRegion, SubGeographicalRegionService } from 'shared-lib';
import { RegionService } from 'src/app/services/region.service';
import { TranslationService } from 'src/app/services/translation.service';

@Component({
  selector: 'app-meter-management-list',
  templateUrl: './meter-stock-inventory.component.html',
  styleUrls: ['./meter-stock-inventory.component.scss'],
})
export class MeterStockInventory implements OnInit {
  @ViewChild('closeCanvas') closeButton: ElementRef;

  buName: string = this.translationService.getByKeyFromStorage('BU');
  utName: string = this.translationService.getByKeyFromStorage('UT');
  utilityId: number = 0;
  count: number = 0;
  pageSize: number = 10;
  currentPage: number = 1;
  searchText: string = '';
  searchTextUpdate = new Subject<string>();
  searchFilterApplied: boolean = false;
  selectedSearchType: string;
  selectedSearchTypeDisplay: string;
  showSelectSearchType: boolean = false;
  searchByOptions = [
    { name: 'MeterNumber', value: 'Meter No.', translation: 'CUSTOMERS.SEARCH_BY.METER_NO' },
    { name: 'SerialNumber', value: 'Serial No.', translation: 'CUSTOMERS.SEARCH_BY.SERIAL_NO' },
  ];
  ctvtSearchByOptions = [
    { name: 'TagSerialNumber', value: 'Tag S/N', translation: 'COMMON.MBC_DETAILS.TAG_SERIAL_NUMBER' },
    { name: 'InstrumentSerialNumber', value: 'Instrument S/N', translation: 'COMMON.MBC_DETAILS.INSTRUMENT_SERIAL_NUMBER' },
  ];
  dateTypes = [
    { name: 'DispatchDate', value: 'Dispatch Date', translation: 'COMMON.DATE_TYPE.DISPATCH_DATE' },
    { name: 'InstallationDate', value: 'Date of Installation', translation: 'COMMON.DATE_TYPE.INSTALLATION_DATE' },
    { name: 'UploadDate', value: 'Stock Upload Date', translation: 'COMMON.DATE_TYPE.UPLOAD_DATE' },
  ];
  selectedDateType: string;
  selectedDateTypeDisplay: string;
  showSelectDateType: boolean = false;
  dateFrom: string;
  dateTo: string;

  showUpload: boolean = false;
  regions: Region[] = [];
  areas: Area[] = [];
  allAreas: Area[] = [];
  clicked: boolean = false;
  selectedAreas: number[] = [];
  selectedRegions: number[] = [];
  hasCimDataIntegration: boolean = false;
  geographicalRegions: (GeographicalRegion & { checked?: boolean })[] = [];
  allSubGeographicalRegions: (SubGeographicalRegion & { checked?: boolean })[] = [];
  subGeographicalRegions: (SubGeographicalRegion & { checked?: boolean })[] = [];
  selectedGeographicalRegions: number[] = [];
  selectedSubGeographicalRegions: number[] = [];
  selectedFilters: ChecklistItem[] = [];
  customerType?: number;
  clickObservable: Observable<Event> = fromEvent(document, 'click');
  stats = new MeterStockItemStats();
  customerTypeOptions = [
    { name: 'Prepaid', value: CustomerType.Prepaid, translation: 'COMMON.CUSTOMER_TYPE_OPTIONS.PREPAID' },
    { name: 'Postpaid', value: CustomerType.Postpaid, translation: 'COMMON.CUSTOMER_TYPE_OPTIONS.POSTPAID' },
  ];
  allCheckboxesChecked: boolean = false;
  private ngUnsubscribe = new Subject<void>();
  meterStockItems: MeterStockItem[] = [];
  meterPhaseOptions = [
    { name: 'Single Phase', value: TypeOfConnection.SinglePhase, translation: 'COMMON.CUSTOMER.PHASE_OPTIONS.SINGLE' },
    { name: 'Three Phase', value: TypeOfConnection.ThreePhase, translation: 'COMMON.CUSTOMER.PHASE_OPTIONS.THREE' },
  ];
  meterPhase?: number;
  totalInfoOpen: boolean = false;

  MeterInventoryType = MeterInventoryType;
  selectedInventoryType: MeterInventoryType = MeterInventoryType.Customer;

  meterBrandOptions: OptionObj[] = [];
  allMeterModels: MeterModel[] = [];
  meterModelOptions: MeterModel[] = [];
  allMeterRatings: MeterRating[] = [];
  meterRatingFilterOptions: MeterRating[] = [];
  meterRatingOptions: MeterRating[] = [];
  meterRatingId?: number;
  dtMeterTypeOptions: DtMeterType[] = [];

  CtvtVoltageLevel = CtvtVoltageLevel;
  CtvtVoltageLevelDisplay = CtvtVoltageLevelDisplay;
  voltageLevelOptions = [
    { value: CtvtVoltageLevel.Ratio_11000_110, display: CtvtVoltageLevelDisplay[CtvtVoltageLevel.Ratio_11000_110] },
    { value: CtvtVoltageLevel.Ratio_33000_110, display: CtvtVoltageLevelDisplay[CtvtVoltageLevel.Ratio_33000_110] },
  ];
  voltageLevel?: CtvtVoltageLevel;

  newMeter: NewMeterStockItemDto = new NewMeterStockItemDto();
  constructor(
    private meterManagementService: MeterManagementService,
    private translationService: TranslationService,
    private regionService: RegionService,
    private areaService: AreaService,
    private toastr: ToastrService,
    private meterService: MeterService,
    private meterModelService: MeterModelService,
    private meterRatingService: MeterRatingService,
    private dtMeterTypeService: DtMeterTypeService,
    public permissionsService: PermissionsService,
    public authService: AuthService,
    private geographicalRegionService: GeographicalRegionService,
    private subGeographicalRegionService: SubGeographicalRegionService
  ) {
    this.hasCimDataIntegration = this.authService.hasCimDataIntegration;
  }

  

  ngOnInit(): void {
    this.subscribeToClickEvent();

    if (this.permissionsService.hasDashboardConfigMeterCustomers && this.permissionsService.isCustomerMeterStockInventoryViewAllowed) {
      this.selectedInventoryType = MeterInventoryType.Customer;
    } else if (this.permissionsService.hasDashboardConfigMeterAssets && this.permissionsService.isAssetMeterStockInventoryViewAllowed) {
      this.selectedInventoryType = MeterInventoryType.Asset;
    } else if (this.permissionsService.hasDashboardConfigMeterCtvt && this.permissionsService.isCtvtMeterStockInventoryViewAllowed) {
      this.selectedInventoryType = MeterInventoryType.Ctvt;
    }

    this.utilityId = parseInt(localStorage.getItem('utilityId') || '');
    this.searchTextUpdate.pipe(debounceTime(500)).subscribe((value) => {
      if (this.searchText == '') this.search();
    });
    this.selectedDateType = this.selectedDateType ?? this.dateTypes[0].name;
    this.selectedDateTypeDisplay =
      this.selectedDateTypeDisplay ?? this.dateTypes[0].translation;

    this.selectedSearchType =
      this.selectedSearchType ?? this.searchByOptions[0].name;
    this.selectedSearchTypeDisplay =
      this.selectedSearchTypeDisplay ?? this.searchByOptions[0].translation;
    if (this.hasCimDataIntegration) {
      this.getGeographicalRegions();
    } else {
      this.getAreas();
      this.getRegions();
    }
    this.reloadTable();
    this.getMeterBrandsForOptions();
    this.getMeterModels();
    this.getDtMeterTypes();
    this.getMeterRatings();
  }
  pageChange(value: any) {
    this.currentPage = value;
    this.reloadTable();
  }
  private subscribeToClickEvent() {
    this.clickObservable
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe((e: any) => {
        this.showUpload = false;
        this.showSelectDateType = false;
        this.showSelectSearchType = false;
      });
  }
  search() {
    this.searchFilterApplied = this.searchText ? true : false;
    this.reloadTable(1);
  }
  getStats() {
    var obj = this.getFilterObject();
    this.getTotalStats(obj);
    this.getSinglePhaseStats(obj);
    this.getThreePhaseStats(obj);
    this.getInStorageStats(obj);
    this.getInstalledStats(obj);
    this.getAvgAgeStats(obj);
  }
  getTotalStats(obj: any) {
    var filter = {
      filter: obj,
      Option: MeterManagementStatsOptions.Total,
    };
    this.meterManagementService.getStats(filter).subscribe({
      next: (response) => {
        const data = response.body;
        if (data?.status === 200 || data?.status === 'OK') {
          this.stats.total = data.data.total;
        } else {
          this.toastr.error(data?.message);
        }
      },
      error: (_) => {
        this.toastr.error('Error occured');
      },
    });
  }
  getSinglePhaseStats(obj: any) {
    var filter = {
      filter: obj,
      Option: MeterManagementStatsOptions.SinglePhase,
    };
    this.meterManagementService.getStats(filter).subscribe({
      next: (response) => {
        const data = response.body;
        if (data?.status === 200 || data?.status === 'OK') {
          this.stats.singlePhase = data.data.singlePhase;
        } else {
          this.toastr.error(data?.message);
        }
      },
      error: (_) => {
        this.toastr.error('Error occured');
      },
    });
  }
  getThreePhaseStats(obj: any) {
    var filter = {
      filter: obj,
      Option: MeterManagementStatsOptions.ThreePhase,
    };
    this.meterManagementService.getStats(filter).subscribe({
      next: (response) => {
        const data = response.body;
        if (data?.status === 200 || data?.status === 'OK') {
          this.stats.threePhase = data.data.threePhase;
        } else {
          this.toastr.error(data?.message);
        }
      },
      error: (_) => {
        this.toastr.error('Error occured');
      },
    });
  }
  getInStorageStats(obj: any) {
    var filter = {
      filter: obj,
      Option: MeterManagementStatsOptions.InStorage,
    };
    this.meterManagementService.getStats(filter).subscribe({
      next: (response) => {
        const data = response.body;
        if (data?.status === 200 || data?.status === 'OK') {
          this.stats.inStorage = data.data.inStorage;
        } else {
          this.toastr.error(data?.message);
        }
      },
      error: (_) => {
        this.toastr.error('Error occured');
      },
    });
  }
  getInstalledStats(obj: any) {
    var filter = {
      filter: obj,
      Option: MeterManagementStatsOptions.Installed,
    };
    this.meterManagementService.getStats(filter).subscribe({
      next: (response) => {
        const data = response.body;
        if (data?.status === 200 || data?.status === 'OK') {
          this.stats.installed = data.data.installed;
        } else {
          this.toastr.error(data?.message);
        }
      },
      error: (_) => {
        this.toastr.error('Error occured');
      },
    });
  }
  getAvgAgeStats(obj: any) {
    var filter = {
      filter: obj,
      Option: MeterManagementStatsOptions.AverageAge,
    };
    this.meterManagementService.getStats(filter).subscribe({
      next: (response) => {
        const data = response.body;
        if (data?.status === 200 || data?.status === 'OK') {
          this.stats.averageAge = data.data.averageAge;
        } else {
          this.toastr.error(data?.message);
        }
      },
      error: (_) => {
        this.toastr.error('Error occured');
      },
    });
  }
  private getRegions() {
    this.regionService.getAllForSelect().subscribe({
      next: (response) => {
        const responseData = response.body;
        if (responseData?.status === 200 || responseData?.status === 'OK') {
          this.regions = responseData.data;
          this.getAreas();
        } else if (response?.status == 204) {
        } else {
          this.toastr.error(responseData?.message);
        }
      },
      error: (_) => {
        this.toastr.error('Error occured');
      },
    });
  }
  private getAreas() {
    this.areaService.getAllForSelect().subscribe({
      next: (response) => {
        const responseData = response.body;
        if (responseData?.status === 200 || responseData?.status === 'OK') {
          this.allAreas = responseData.data;
          this.areas = this.allAreas.filter((area) =>
            this.regions.some(
              (region) => region.id == area.regionId && region.checked
            )
          );
        } else if (response?.status == 204) {
        } else {
          this.toastr.error(responseData?.message);
        }
      },
      error: (_) => {
        this.toastr.error('Error occured');
      },
    });
  }
  private getGeographicalRegions() {
    this.geographicalRegionService.getAllForSelect().subscribe({
      next: (response) => {
        const responseData = response.body;
        if (responseData?.status === 200 || responseData?.status === 'OK') {
          this.geographicalRegions = responseData.data;
          this.getSubGeographicalRegions();
        } else if (response?.status == 204) {
        } else {
          this.toastr.error(responseData?.message);
        }
      },
      error: (_) => {
        this.toastr.error('Error occured');
      },
    });
  }
  private getSubGeographicalRegions() {
    this.subGeographicalRegionService.getAllForMappings().subscribe({
      next: (response) => {
        const responseData = response.body;
        if (responseData?.status === 200 || responseData?.status === 'OK') {
          this.allSubGeographicalRegions = responseData.data;
          this.subGeographicalRegions = this.allSubGeographicalRegions.filter((sub) =>
            this.geographicalRegions.some(
              (region) => region.id == sub.geographicalRegion.id && region.checked
            )
          );
        } else if (response?.status == 204) {
        } else {
          this.toastr.error(responseData?.message);
        }
      },
      error: (_) => {
        this.toastr.error('Error occured');
      },
    });
  }
  selectGeographicalRegion(e: any) {
    this.subGeographicalRegions = this.allSubGeographicalRegions.filter((sub) =>
      this.geographicalRegions.some(
        (region) => region.id == sub.geographicalRegion.id && region.checked
      )
    );
    this.allSubGeographicalRegions.forEach((sub) => {
      if (!this.subGeographicalRegions.some((s) => s.id === sub.id)) {
        sub.checked = false;
      }
    });
    this.createFilterCards();
  }
  selectSubGeographicalRegion(e: any) {
    this.createFilterCards();
  }
  reloadTable(page: any = null) {
    this.allCheckboxesChecked = false;
    if (page) this.currentPage = page;

    let obj = {
      pageInfo: {
        page: this.currentPage,
        pageSize: this.pageSize,
        count: this.count,
      },
      filterParams: this.getFilterObject(),
    };

    this.getAll(obj);
    this.getStats();
  }
  getFilterObject() {
    let obj = {
      search: this.searchText,
      searchType: this.selectedSearchType,
      dateFrom: this.dateFrom ? this.dateFrom : null,
      dateTo: this.dateTo ? `${this.dateTo}T23:59:59` : null,
      dateType: this.selectedDateType,
      selectedAreas: this.selectedAreas.length > 0 ? this.selectedAreas : null,
      selectedRegions:
        this.selectedRegions.length > 0 ? this.selectedRegions : null,
      selectedGeographicalRegions:
        this.selectedGeographicalRegions.length > 0 ? this.selectedGeographicalRegions : null,
      selectedSubGeographicalRegions:
        this.selectedSubGeographicalRegions.length > 0 ? this.selectedSubGeographicalRegions : null,
      selectedIds: this.meterStockItems
        .filter((x) => x.isChecked == true)
        .map((x) => x.id),
      meterType: this.isCtvtInventory ? undefined : this.customerType,
      meterPhase: this.isNonCustomerInventory ? undefined : this.meterPhase,
      meterRatingId: this.isNonCustomerInventory ? this.meterRatingId : undefined,
      meterInventoryType: this.selectedInventoryType,
      voltageLevel: this.isCtvtInventory ? this.voltageLevel : undefined,
    };
    return obj;
  }

  get isNonCustomerInventory(): boolean {
    return this.selectedInventoryType !== MeterInventoryType.Customer;
  }

  get isCtvtInventory(): boolean {
    return this.selectedInventoryType === MeterInventoryType.Ctvt;
  }

  changeInventoryType(type: MeterInventoryType) {
    if (this.selectedInventoryType === type) return;
    this.selectedInventoryType = type;
    this.stats = new MeterStockItemStats();
    this.meterPhase = undefined;
    this.meterRatingId = undefined;
    this.voltageLevel = undefined;
    this.customerType = undefined;
    this.searchText = '';
    this.searchFilterApplied = false;
    const searchOptions = this.isCtvtInventory ? this.ctvtSearchByOptions : this.searchByOptions;
    this.selectedSearchType = searchOptions[0].name;
    this.selectedSearchTypeDisplay = searchOptions[0].translation;
    this.setMeterRatingFilterOptions();
    this.createFilterCards();
    this.reloadTable(1);
  }
  private getAll(obj: any) {
    this.meterManagementService.getAll(obj).subscribe({
      next: (response) => {
        const responseData = response;
        if (responseData?.status === 200 || responseData?.status === 'OK') {
          this.meterStockItems = responseData.data.data; 
          this.count = responseData.data.count ?? this.count;
          if (responseData.message != '') {
            this.toastr.warning(responseData.message);
          }
        } else {
          this.toastr.error(responseData?.message);
        }
      },
      error: (_) => this.toastr.error('Error occured'),
    });
  }
  selectSearchType(searchType: any) {
    if (this.searchText && this.searchFilterApplied) {
      this.searchText = '';
      this.search();
    }
    this.selectedSearchType = searchType.name;
    this.selectedSearchTypeDisplay = searchType.translation;
    this.showSelectSearchType = false;
  }
  selectDateType(dateType: any) {
    this.selectedDateType = dateType.name;
    this.selectedDateTypeDisplay = dateType.translation;
    this.showSelectDateType = false;
  }
  datesValid() {
    if (this.dateFrom && this.dateTo && this.dateTo?.toString() != '') {
      const valid: boolean =
        new Date(this.dateFrom).getTime() <
        new Date(`${this.dateTo.toString()}T23:59:59`).getTime();
      return valid;
    }
    return true;
  }

  download() {
    var obj = this.getFilterObject();
    this.meterManagementService.download(obj).subscribe({
      next: (response) => {
        const data = response.body;
        if (data?.status === 'OK' || data?.status === '200') {
          window.location.href = data.data;
        } else if (data?.status === 'Pending' || data?.status === '600') {
          this.toastr.info(data?.message || '');
        } else this.toastr.error(data?.message || 'Request failed');
      },
      error: (error) => console.log(error),
    });
  }
  selectRegion(e: any) {
    //list of areas for selected regions
    this.areas = this.allAreas.filter((area) =>
      this.regions.some(
        (region) => region.id == area.regionId && region.checked
      )
    );
    this.allAreas.forEach((area) => {
      if (!this.areas.some((a) => a.id === area.id)) {
        area.checked = false; //uncheck areas for unchecked regions
      }
    });
    this.createFilterCards();
  }
  selectArea(e: any) {
    this.createFilterCards();
  }
  createFilterCards() {
    this.selectedFilters = [];
    let selectedRegions = this.regions.filter((x) => x.checked);
    let selectedAreas = this.areas.filter((x) => x.checked);
    this.selectedAreas = this.areas.filter((x) => x.checked).map((x) => x.id);
    this.selectedRegions = this.regions
      .filter((x) => x.checked)
      .map((x) => x.id);
    let selectedGeographicalRegions = this.geographicalRegions.filter((x) => x.checked);
    let selectedSubGeographicalRegions = this.subGeographicalRegions.filter((x) => x.checked);
    this.selectedGeographicalRegions = this.geographicalRegions
      .filter((x) => x.checked)
      .map((x) => x.id as number);
    this.selectedSubGeographicalRegions = this.subGeographicalRegions
      .filter((x) => x.checked)
      .map((x) => x.id as number);
    if (this.hasCimDataIntegration) {
      //geographical regions
      for (var i = 0; i < selectedGeographicalRegions.length; i++) {
        this.selectedFilters.push(
          new ChecklistItem(this.buName, selectedGeographicalRegions[i].name, 'COMMON.BU.SINGLE')
        );
      }
      //sub geographical regions
      for (var i = 0; i < selectedSubGeographicalRegions.length; i++) {
        this.selectedFilters.push(
          new ChecklistItem(this.utName, selectedSubGeographicalRegions[i].name, 'COMMON.UT.SINGLE')
        );
      }
    } else {
      //regions
      for (var i = 0; i < selectedRegions.length; i++) {
        this.selectedFilters.push(
          new ChecklistItem(this.buName, selectedRegions[i].name, 'COMMON.BU.SINGLE')
        );
      }
      //areas
      for (var i = 0; i < selectedAreas.length; i++) {
        this.selectedFilters.push(
          new ChecklistItem(this.utName, selectedAreas[i].name, 'COMMON.UT.SINGLE')
        );
      }
    }
    if (this.meterPhase && !this.isNonCustomerInventory) {
      let status = this.meterPhaseOptions.filter((option) => option.value == this.meterPhase)[0];
      this.selectedFilters.push(new ChecklistItem('Meter Phase', status.name, 'COMMON.MBC_DETAILS.METER_PHASE', status.translation));
    }
    if (this.meterRatingId && this.isNonCustomerInventory) {
      let rating = this.meterRatingFilterOptions.filter((option) => option.id == this.meterRatingId)[0];
      this.selectedFilters.push(new ChecklistItem('Meter Rating', rating.ratingDisplay, 'COMMON.MBC_DETAILS.METER_RATING.SINGLE'));
    }
    if (this.customerType && !this.isCtvtInventory) {
      let status = this.customerTypeOptions.filter((option) => option.value == this.customerType)[0];
      this.selectedFilters.push(new ChecklistItem('Meter Type', status.name, 'COMMON.MBC_DETAILS.METER_TYPE.SINGLE', status.translation));
    }
    if (this.voltageLevel && this.isCtvtInventory) {
      this.selectedFilters.push(new ChecklistItem('Voltage Level', this.CtvtVoltageLevelDisplay[this.voltageLevel], 'COMMON.MBC_DETAILS.VOLTAGE_LEVEL'));
    }
  }
  selectCustomerType(e: any) {
    if (e.target.value != '') {
      this.customerType = e.target.value;
    } else {
      this.customerType = undefined;
    }
    this.createFilterCards();
    this.reloadTable(1);
  }
  selectMeterPhase(e: any) {
    if (e.target.value != '') {
      this.meterPhase = e.target.value;
    } else {
      this.meterPhase = undefined;
    }
    this.createFilterCards();
    this.reloadTable(1);
  }
  selectMeterRating(e: any) {
    if (e.target.value != '') {
      this.meterRatingId = parseInt(e.target.value);
    } else {
      this.meterRatingId = undefined;
    }
    this.createFilterCards();
    this.reloadTable(1);
  }
  selectVoltageLevel(e: any) {
    if (e.target.value != '') {
      this.voltageLevel = parseInt(e.target.value);
    } else {
      this.voltageLevel = undefined;
    }
    this.createFilterCards();
    this.reloadTable(1);
  }
  resetFilter(e: any) {
    this.selectedFilters = [];
    this.regions.forEach((region) => {
      region.checked = false;
    });
    this.areas.forEach((area) => {
      area.checked = false;
    });
    this.areas = [];
    this.selectedAreas = [];
    this.selectedRegions = [];
    this.geographicalRegions.forEach((region) => {
      region.checked = false;
    });
    this.subGeographicalRegions.forEach((sub) => {
      sub.checked = false;
    });
    this.subGeographicalRegions = [];
    this.selectedGeographicalRegions = [];
    this.selectedSubGeographicalRegions = [];
    this.meterPhase = undefined;
    this.meterRatingId = undefined;
    this.customerType = undefined;
    this.voltageLevel = undefined;
    this.clicked = !this.clicked;
    this.reloadTable(1);
  }
  removeFilter(item: ChecklistItem) {
    if (item.property == this.buName) {
      if (this.hasCimDataIntegration) {
        this.geographicalRegions.forEach((region) => {
          if (region.name === item.selectedValue) {
            region.checked = false;
          }
        });
        this.selectGeographicalRegion(event);
      } else {
        this.regions.forEach((region) => {
          if (region.name === item.selectedValue) {
            region.checked = false;
          }
        });
        this.selectRegion(event);
      }
      this.clicked = !this.clicked;
    } else if (item.property == this.utName) {
      if (this.hasCimDataIntegration) {
        this.subGeographicalRegions.forEach((sub) => {
          if (sub.name === item.selectedValue) {
            sub.checked = false;
          }
        });
      } else {
        this.areas.forEach((area) => {
          if (area.name === item.selectedValue) {
            area.checked = false;
          }
        });
      }
      this.clicked = !this.clicked;
    } else if (item.property == 'Meter Phase') {
      this.meterPhase = undefined;
    } else if (item.property == 'Meter Rating') {
      this.meterRatingId = undefined;
    } else if (item.property == 'Meter Type') {
      this.customerType = undefined;
    } else if (item.property == 'Voltage Level') {
      this.voltageLevel = undefined;
    }
    this.createFilterCards();
    this.reloadTable(1);
  }
  checkAllCheckboxes() {
    this.meterStockItems.forEach(
      (x) => (x.isChecked = !this.allCheckboxesChecked)
    );
    this.allCheckboxesChecked = !this.allCheckboxesChecked;
  }
  areAllCheckboxesChecked() {
    this.allCheckboxesChecked = this.meterStockItems.every((x) => x.isChecked);
  }
  getAgeClass(lifespan: number, age: number) {
    var percent = (age / lifespan) * 100;
    if (percent < 40 || Number.isNaN(percent)) return 'green';
    else if (percent < 85) return 'yellow';
    else return 'red';
  }
  checkMeterStockItem(id: number) {
    const meterStockItems = this.meterStockItems.find((x) => x.id === id);
    if (meterStockItems) {
      meterStockItems.isChecked = !meterStockItems.isChecked;
      this.areAllCheckboxesChecked();
    }
  }

  getMeterBrandsForOptions(){
    this.meterService.getMeterTypesForOptions().subscribe(response => {
      this.meterBrandOptions = response.body.data;
    }, error => {
      this.toastr.error('An error occurred.');
    });
  }

  getMeterModels() {
    this.meterModelService.getAllForSelect().subscribe({
      next: (response) => {
        this.allMeterModels = response.body?.data ?? [];
      },
      error: (_) => {
        this.toastr.error('An error occurred.');
      },
    });
  }

  getDtMeterTypes() {
    this.dtMeterTypeService.getAllForSelect().subscribe({
      next: (response) => {
        this.dtMeterTypeOptions = response.body?.data ?? [];
      },
      error: (_) => {
        this.toastr.error('An error occurred.');
      },
    });
  }

  getMeterRatings() {
    this.meterRatingService.getAllForSelect().subscribe({
      next: (response) => {
        this.allMeterRatings = (response?.data ?? []).map(
          (meterRating: any) => new MeterRating(meterRating)
        );
        this.setMeterRatingFilterOptions();
      },
      error: (_) => {
        this.toastr.error('An error occurred.');
      },
    });
  }

  private setMeterRatingFilterOptions() {
    this.meterRatingFilterOptions = this.allMeterRatings.filter(
      (x) => x.dtMeterTypeIds.length > 0
    );
  }

  onMeterMakeChange() {
    this.newMeter.meterModelId = undefined;
    this.newMeter.meterRatingId = undefined;
    this.meterModelOptions = this.newMeter.meterMakeId
      ? this.allMeterModels.filter((x) => x.meterBrand?.id === this.newMeter.meterMakeId)
      : [];
    this.recomputeMeterRatingOptions();
  }

  onDtMeterTypeChange() {
    this.newMeter.meterRatingId = undefined;
    this.recomputeMeterRatingOptions();
  }

  private recomputeMeterRatingOptions() {
    if (this.isCtvtInventory) {
      if (!this.newMeter.dtMeterTypeId) {
        this.meterRatingOptions = [];
        return;
      }
      this.meterRatingOptions = this.meterRatingFilterOptions.filter((x) =>
        x.dtMeterTypeIds.includes(this.newMeter.dtMeterTypeId!)
      );
      return;
    }
    if (!this.newMeter.meterMakeId) {
      this.meterRatingOptions = [];
      return;
    }
    if (!this.newMeter.dtMeterTypeId) {
      this.meterRatingOptions = [];
      return;
    }
    this.meterRatingOptions = this.meterRatingFilterOptions.filter(
      (x) =>
        x.meterBrandIds.includes(this.newMeter.meterMakeId!) &&
        x.dtMeterTypeIds.includes(this.newMeter.dtMeterTypeId!)
    );
  }

  submitMeterStockItem() {
    if(this.validateNewMeter()) {
      this.meterManagementService.save(this.newMeter).subscribe(response => {
        if(response?.body?.status == 'BadRequest') {
          this.toastr.error(response?.body?.message);
        }
        else {
          this.toastr.success(response?.body?.message);
          this.initializeNewMeter();
          this.closeButton.nativeElement.click();
          this.reloadTable();
        }
      }, error => {
        this.toastr.error('An error occurred.');
      })
    }
  }

  validateNewMeter() {
    if (this.isCtvtInventory) {
      if ((!this.newMeter.tagSerialNumber || this.newMeter.tagSerialNumber.trim() == '') ||
          (!this.newMeter.instrumentSerialNumber || this.newMeter.instrumentSerialNumber.trim() == '') ||
          !this.newMeter.voltageLevel ||
          !this.newMeter.dtMeterTypeId ||
          !this.newMeter.meterRatingId ||
          !this.newMeter.dispatchDate) {
        this.toastr.warning('All input fields are mandatory!');
        return false;
      }

      const now = new Date();
      if (Date.parse(this.newMeter.dispatchDate) > now.getTime()) {
        this.toastr.warning('Please select a valid dispatch date.');
        return false;
      }

      return true;
    }

    if((!this.newMeter.meterNumber || this.newMeter.meterNumber.trim() == '') ||
        (this.isNonCustomerInventory && !this.newMeter.meterRatingId) ||
        (!this.isNonCustomerInventory && this.newMeter.meterPhase == null) ||
        (!this.isNonCustomerInventory && (!this.newMeter.preloadedUnits || this.newMeter.preloadedUnits.trim() == '')) ||
        !this.newMeter.meterMakeId ||
        !this.newMeter.meterModelId ||
        (this.isNonCustomerInventory && !this.newMeter.dtMeterTypeId) ||
        !this.newMeter.dispatchDate ||
        !this.newMeter.lifespan
      ) {
      this.toastr.warning('All input fields are mandatory!');
      return false;
    }

    if (!/^[a-zA-Z0-9]+$/.test(this.newMeter.meterNumber)) {
      this.toastr.warning('Meter number cannot contain special characters.');
      return false;
    }

    if (!this.isNonCustomerInventory &&
        (!/^\d{3}$/.test(this.newMeter.preloadedUnits!.trim()) || Number(this.newMeter.preloadedUnits) > 301)) {
      this.toastr.warning('Preloaded Units must be exactly 3 digits with a maximum value of 301.');
      return false;
    }

    const now = new Date();
    if (Date.parse(this.newMeter.dispatchDate) > now.getTime()) {
      this.toastr.warning('Please select a valid dispatch date.');
      return false;
    }

    return true;
  }

  allowOnlyDigits(event: KeyboardEvent) {
    if (!/^[0-9]$/.test(event.key)) {
      event.preventDefault();
    }
  }

  allowOnlyAlphaNumeric(event: KeyboardEvent) {
    const char = event.key.toUpperCase();
    const isValid = /^[a-zA-Z0-9]$/.test(char);
    if (!isValid) {
      event.preventDefault();
    }
  }

  initializeNewMeter() {
    this.newMeter = new NewMeterStockItemDto();
    this.newMeter.meterInventoryType = this.selectedInventoryType;
    this.meterModelOptions = [];
    this.meterRatingOptions = [];
  }
}
